import { render } from "./ForgotPasswordPopup.vue?vue&type=template&id=33210872&scoped=true&ts=true"
import script from "./ForgotPasswordPopup.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPopup.vue?vue&type=script&lang=ts"

import "./ForgotPasswordPopup.vue?vue&type=style&index=0&id=33210872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33210872"]])

export default __exports__